import AdvancedSearch from './AdvancedSearch.jsx';

export {
  AdvancedSearch
}


// WEBPACK FOOTER //
// ./components/list-product/advanced-search/index.js